import { render } from "./MigrationWarningStep.vue?vue&type=template&id=99c4a31c"
import script from "./MigrationWarningStep.vue?vue&type=script&lang=ts"
export * from "./MigrationWarningStep.vue?vue&type=script&lang=ts"
script.render = render

export default script